var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.40723,72.72314c-.0127-.02368-.01856-.04907-.03223-.07251-.00391-.00732-.00977-.01293-.01416-.02026a11.99344,11.99344,0,0,0-4.47754-4.41064l-88-49.5a12.07124,12.07124,0,0,0-11.7666,0l-88,49.5a11.99326,11.99326,0,0,0-4.48389,4.42334c-.00586.01025-.01367.01782-.01953.02783-.01416.02588-.02051.05347-.03418.07959A11.98438,11.98438,0,0,0,28,78.67871v98.64258a12.01534,12.01534,0,0,0,6.1167,10.459l88.00049,49.5a11.97922,11.97922,0,0,0,5.606,1.51343c.085.0061.16553.02686.252.02759h.03613c.1001,0,.19434-.022.293-.0293a11.98372,11.98372,0,0,0,5.5791-1.51172l88-49.5A12.01534,12.01534,0,0,0,228,177.32129V78.67871A11.98919,11.98919,0,0,0,226.40723,72.72314ZM126.03906,25.69238a4.02317,4.02317,0,0,1,3.92188,0l85.91113,48.32471-86.94238,49.39355L40.18945,73.98291Zm-88,155.11524A4.00514,4.00514,0,0,1,36,177.32129V80.80664l88.92822,49.53223-.86865,98.85547Zm179.92188,0-85.90039,48.31909.86816-98.78711L220,80.87305v96.44824A4.00514,4.00514,0,0,1,217.96094,180.80762Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.d3067ab68509bc2c6844af917429be98.svg";
export { ForwardRef as ReactComponent };